import { useClient } from '../useClient';
import type { ExtendedOptions } from '../useClient';
import type { ChatwootContact } from 'models/Chatwoot';

export function useUserChatwootContact({ userId, options }: { userId?: number; options?: ExtendedOptions }) {
    return useClient<ChatwootContact>({ url: `support/admin/chatwoot-contact/find/?user_id=${userId}`, options });
}
